import { Box } from '@mui/material'
import React from 'react'
import { Trans } from 'react-i18next'

export const LinkChargingCardNoteStep: React.FC = () => {
  return (
    <Box mt={2}>
      <Trans i18nKey="emobility.tour.charging-cards-dialog-link-content" components={{ strong: <strong /> }} />
    </Box>
  )
}
